import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  class: "card-content",
  "data-cy": "card-content"
}

import { computed, ref, onMounted, watch } from "vue";
import { VIconSvg } from "@/components";
import { TranslateResult } from "vue-i18n";

export interface Props {
  title?: string | TranslateResult;
  rollable?: boolean;
  opened?: boolean;
  shadow?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VCard',
  props: {
    title: { default: "" },
    rollable: { type: Boolean, default: false },
    opened: { type: Boolean, default: false },
    shadow: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

let isShownContent = ref(false);

const headClasses = computed(() => {
  return {
    "with-chevron": props.rollable,
  };
});

const wrapperClasses = computed(() => {
  return {
    "shadow-outer": props.shadow,
  };
});

const iconClasses = computed(() => {
  return {
    active: isShownContent.value,
  };
});

const toggleContent = () => {
  if (props.rollable) {
    isShownContent.value = !isShownContent.value;
  }
};

watch(() => props.opened, toggleContent);

onMounted(() => {
  isShownContent.value = props.rollable ? props.opened : true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["card-container", wrapperClasses.value]),
        "data-cy": "card-container"
      }, [
        (_ctx.title.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["head", headClasses.value])
            }, [
              _createElementVNode("div", {
                class: "title",
                "data-cy": "card-title",
                innerHTML: _ctx.title
              }, null, 8, _hoisted_1),
              _renderSlot(_ctx.$slots, "title"),
              (_ctx.rollable)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["icon", iconClasses.value]),
                    onClick: toggleContent
                  }, [
                    _createVNode(_unref(VIconSvg), {
                      name: "Chevron",
                      size: "xs",
                      color: "dark-blue",
                      "color-tag": "stroke",
                      class: "arrow-icon"
                    })
                  ], 2))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "slide-fade-card-content" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ], 512), [
              [_vShow, _unref(isShownContent)]
            ])
          ], undefined, true),
          _: 3
        })
      ], 2)
    ], undefined, true),
    _: 3
  }))
}
}

})